import React from 'react';

import { Flex, Icon, Box, Text } from '@chakra-ui/react';

export default function TimelineRow({
  icon,
  iconColor,
  title,
  description,
  isLast,
}: {
  title: React.ReactNode;
  icon: (props: React.SVGProps<SVGSVGElement>) => React.ReactNode;
  iconColor?: string;
  description?: React.ReactNode;
  isLast: boolean;
}) {
  return (
    <Flex
      alignItems="center"
      minH="4rem"
      maxW="xs"
      justifyContent="start"
      mb={isLast ? "" : "5px"}
    >
      <Flex direction="column" h="100%">
        <Icon
          as={icon}
          color={iconColor}
          h="30px"
          w="26px"
          pe="0.5"
          zIndex="1"
          position="relative"
        />
        <Box w="2px" bg="gray.200" h={isLast ? "15px" : "100%"} ml="2.5" />
      </Flex>
      <Flex
        direction="column"
        minW="0"
        justifyContent="flex-start"
        h="100%"
        ml="3"
      >
        <Text as="div" fontSize="sm" fontWeight="bold" whiteSpace="break-spaces">
          {title}
        </Text>
        {description && (
          <Text as="div" fontSize="sm" color="gray.400" fontWeight="normal" isTruncated>
            {description}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}